import { ReactNode, useMemo } from 'react';

import { useParams } from 'react-router-dom';

import {
  WorkloadDetailsProvider,
  WorkloadSelectedContainerProvider,
} from '@cast/split-me/features/cluster/workload-optimization';

import { useInventoryWorkloadsTimeRangeSelection } from '../../_hooks/useInventoryWorkloadsTimeRangeSelection';
import { capWorkloadAutoscalingRange } from '../_utils/capWorkloadAutoscalingRange';

type Props = {
  children: ReactNode;
};

export const InventoryWorkloadDetailsProvider = ({ children }: Props) => {
  const { workloadId } = useParams<{ workloadId: string }>();
  const { getRange, preset, timeZone, key } =
    useInventoryWorkloadsTimeRangeSelection();

  const timeRangeSelection = useMemo(() => {
    const cappedRange = capWorkloadAutoscalingRange(getRange());
    const cappedKey = `${cappedRange.from}-${cappedRange.to}-${preset}-${timeZone}`;

    return {
      getRange: () => cappedRange,
      preset,
      timeZone,
      key: cappedKey,
    };
  }, [getRange, preset, timeZone, key]);

  if (!workloadId) {
    return null;
  }

  return (
    <WorkloadDetailsProvider
      workloadId={workloadId}
      timeRangeSelection={timeRangeSelection}
    >
      <WorkloadSelectedContainerProvider>
        {children}
      </WorkloadSelectedContainerProvider>
    </WorkloadDetailsProvider>
  );
};
